export default __webpack_public_path__ + "static/media/harvardLogo.9ac340da.png";